import api from './api';

export const reviewService = {
  create: async (appointmentId, rating, comment) => {
    const response = await api.post('/reviews/', {
      appointment: appointmentId,
      rating,
      comment,
    });
    return response.data;
  },

  getByChimney: async (chimneyId) => {
    const response = await api.get(`/reviews/?chimney=${chimneyId}`);
    return response.data;
  },
};
